export type ClientSettingsType = {
    receiveMarketingEmails?: boolean
    requestedTags?: string
    excludedTags?: string
}

export type LoyaltyPointType = {
    id?: number
    referenceNumber?: string
    loyaltyPoints?: number
    loyaltyPointType?: string
    ownerId?: number
    bruttoPriceValue?: number
    bruttoPriceCurrency?: BruttoPriceCurrencyType
    bruttoPriceInOrgCurrency?: number
    langCode?: string
    serviceName?: string
    lastModificationTime?: string
    processStatus?: string
    serviceType?: string
    transactionStatus?: string
    serviceProcess?: TravelServiceProcessType
}

export type TravelServiceProcessType = {
    startDate?: string
    endDate?: string
    countryId?: number
    cityId?: number
    countryName?: string
    cityName?: string
}

export enum TransactionStatus {
    Pending = 'PENDING',
    Completed = 'COMPLETED',
}

export type LoyaltyPointsFilterType = {
    transactionStatus?: string
    rangeType?: string
    dateFrom?: string
    dateTo?: string
}

export type BruttoPriceCurrencyType = {
    currencyCode?: string
    defaultFractionDigits?: number
    numericCode?: number
    symbol?: string
    displayName?: string
}
